import { motion, useScroll } from "framer-motion";

export default function ScrollProgress() {
    const { scrollYProgress } = useScroll();

    return (
        <motion.div
            className="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-h-1 tw-bg-cyan-400 tw-z-[100]"
            style={{
                scaleX: scrollYProgress,
                transformOrigin: "0%",
            }}
        />
    );
}
